<script>
	export let data = {}	
</script>

<div class="card">
	<div class="card-body overflow-auto" style="max-height:500px;">

		<div class="accordion accordion-flush" id="accordionFlushExample">

		  	<div class="accordion-item">
			    <h2 class="accordion-header" id="flush-headingOne">
			      	<button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseInfo" aria-expanded="false" aria-controls="flush-collapseInfo">Informacion</button>
			    </h2>
			    <div id="flush-collapseInfo" class="accordion-collapse collapse show" aria-labelledby="flush-headingOne" data-bs-parent="#accordionFlushExample">
			      	<div class="accordion-body">
			      		<div class="row">
			      			<div class="col col-sm-2 col-4">Ejecutivo</div>
			      			<div class="col">{data.info.ejecutivo}</div>
			      		</div>
				      	<div class="row">
				      		<div class="col col-sm-2 col-4">Vendedor</div>
				      		<div class="col">{data.info.Vendedor}</div>
				      	</div>
				      	<div class="row">
				      		<div class="col col-sm-2 col-4">Ej.Venta</div>
				      		<div class="col">{data.info.ejecventa}</div>
				      	</div>
				      	<div class="row">
				      		<div class="col col-sm-2 col-4">Iva</div>
				      		<div class="col">{data.info.iva}</div>
				      	</div>
				      	<div class="row">
				      		<div class="col col-sm-2 col-4">Cuit</div>
				      		<div class="col">{data.info.CUIT}</div>
				      	</div>
				      	<div class="row">
				      		<div class="col col-sm-2 col-4">Observacion</div>
				      		<div class="col">{data.info.Observacion}</div>
				      	</div>
			      	</div>
			    </div>
		  	</div>

		  	<div class="accordion-item">
			    <h2 class="accordion-header" id="flush-headingOne">
			      	<button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseCt" aria-expanded="false" aria-controls="flush-collapseCt">Contactos</button>
			    </h2>
			    <div id="flush-collapseCt" class="accordion-collapse collapse" aria-labelledby="flush-headingOne" data-bs-parent="#accordionFlushExample">
			      	<div class="accordion-body">
			      		{#each data.contactos as item, index}
					      	<div class="row">
					      		<div class="col col-sm-2 col-4">Tipo Contacto</div>
					      		<div class="col">{item.IdTipoContacto}</div>
					      	</div>
				      		<div class="row">
				      			<div class="col col-sm-2 col-4">Nombre</div>
				      			<div class="col">{item.Nombre} {item.Apellido}</div>
				      		</div>
				      		<div class="row">
				      			<div class="col col-sm-2 col-4">Sexo</div>
				      			<div class="col">{item.Sexo}</div>
				      		</div>
					      	<div class="row">
					      		<div class="col col-sm-2 col-4">FechaNac.</div>
					      		<div class="col">{item.FechaNacimiento}</div>
					      	</div>
					      	<div class="row">
					      		<div class="col col-sm-2 col-4">Documento</div>
					      		<div class="col">{item.TipoDocumento} {item.NumeroDocumento}</div>
					      	</div>
					      	<div class="row">
					      		<div class="col col-sm-2 col-4">Est.Civil</div>
					      		<div class="col">{item.EstadoCivil}</div>
					      	</div>
					      	<div class="row">
					      		<div class="col col-sm-2 col-4">Ocupacion</div>
					      		<div class="col">{item.Ocupacion}</div>
					      	</div>
					      	<div class="row">
					      		<div class="col col-sm-2 col-4">Te Comercial</div>
					      		<div class="col">{item.TelefonoComercial}</div>
					      	</div>
					      	<div class="row">
					      		<div class="col col-sm-2 col-4">Te Celular</div>
					      		<div class="col">{item.TelefonoCelular}</div>
					      	</div>
					      	<div class="row">
					      		<div class="col col-sm-2 col-4">Te Partic.</div>
					      		<div class="col">{item.TelefonoParticular}</div>
					      	</div>
					      	<div class="row">
					      		<div class="col col-sm-2 col-4">Te Otro</div>
					      		<div class="col">{item.TelefonoOtro}</div>
					      	</div>
					      	<div class="row">
					      		<div class="col col-sm-2 col-4">Email</div>
					      		<div class="col">{item.Email}</div>
					      	</div>
					      	<hr>

					      	<!--div class="row">
					      		<pre>{JSON.stringify(item,null,2)}</pre>
					      	</div-->
					    {/each}
			      	</div>
			    </div>
		  	</div>

		  	<div class="accordion-item">
			    <h2 class="accordion-header" id="flush-headingOne">
			      	<button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseDomi" aria-expanded="false" aria-controls="flush-collapseDomi">Domicilio</button>
			    </h2>
			    <div id="flush-collapseDomi" class="accordion-collapse collapse" aria-labelledby="flush-headingOne" data-bs-parent="#accordionFlushExample">
			      	<div class="accordion-body">
			      		{#each data.domicilios as item, index}
					      	<div class="row">
					      		<div class="col col-sm-2 col-4">Tipo</div>
					      		<div class="col">{item.Tipo}</div>
					      	</div>
				      		<div class="row">
				      			<div class="col col-sm-2 col-4">Domicilio</div>
				      			<div class="col">{item.Domicilio1.trim()}</div>
				      		</div>
				      		<div class="row">
				      			<div class="col col-sm-2 col-4"></div>
				      			<div class="col">{item.Domicilio2.trim()}</div>
				      		</div>
					      	
					      	<hr>
					    {/each}
			      	</div>
			    </div>
		  	</div>

		</div>
		
	</div>
</div>